import { Avatar } from '@chakra-ui/react'
import { theme } from 'twin.macro'
import * as R from 'ramda'

const getRarityColor = R.cond([
  [R.equals('Legendary'), R.always(theme`textColor.legendary.500`)],
  [R.equals('Magic'), R.always(theme`textColor.magic.500`)],
  [R.equals('Prime'), R.always(theme`textColor.prime.500`)],
  [R.T, R.always(theme`textColor.brand.500`)]
])

export default function RaceAvatar({ race, rarity, size }: { race?: string, rarity?: string, size: string }) {
  const src = race ? `/static/origins/avatar-${race}.jpg` : '/static/spirit/spirit.png'
  return (
    <Avatar
      h={size}
      w={size}
      src={src}
      borderWidth={2}
      borderStyle='solid'
      borderColor={getRarityColor(rarity || '')}
    />
  )
}